import { createAsyncThunk } from '@reduxjs/toolkit';
import { PopupNotificationServices } from 'Services/axios/PopupNotification.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchPopupNotification = createAsyncThunk(
  'PopupNotification/fetchPopupNotification',
  async (filters) => {
    try {
      const response = await PopupNotificationServices.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitPopupNotification = createAsyncThunk(
  'addPopupNotification/submitPopupNotification',
  async (data) => {
    try {
      const formData = new FormData();
      // Saat edit, jika image masih berupa string URL/path lama, jangan kirim ulang sebagai file.
      // Backend akan mempertahankan image existing selama field `image` tidak diubah.
      const isImageFile = data?.image instanceof File || data?.image instanceof Blob;
      if (isImageFile) {
        formData.append('image', data.image);
      }

      formData.append('url', data?.url);
      formData.append('target_page', data?.target_page);
      formData.append('is_show', data?.is_show);
      let response;
      if (data.isUpdate) {
        response = await PopupNotificationServices.update(data?.id, formData);
      } else {
        response = await PopupNotificationServices.create(formData);
      }
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deletePopupNotification = createAsyncThunk(
  'deletePopupNotification/deletePopupNotification',
  async (id) => {
    try {
      const response = await PopupNotificationServices.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}